var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unlim-width default-layout swap-widget-container"},[_c('div',{staticClass:"not-footer"},[_c('AlcorLoading'),_c('ResourcesModal'),_c('ModalsDialog'),_c('div',{staticClass:"alcor-inner main"},[_c('TopNav',{staticClass:"mb-2"}),_c('nuxt')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }